// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function BroadcastSearchResultTimestamp(props) {
  let broadcastAt = props.broadcastAt;
  let updatedAt = props.updatedAt;
  let broadcastDistance = UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(broadcastAt));
  let updatedDistance = UTCDate.encodeAsISOString(Scalars.DateTime.toUTC(broadcastAt)) === UTCDate.encodeAsISOString(Scalars.DateTime.toUTC(updatedAt)) ? undefined : UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(updatedAt));
  return JsxRuntime.jsx("div", {
    children: `Broadcast ` + broadcastDistance + ` ago` + Stdlib_Option.getOr(Stdlib_Option.map(updatedDistance, x => ` and updated ` + x + ` ago`), ""),
    className: "text-sm text-gray-500"
  });
}

let make = BroadcastSearchResultTimestamp;

exports.make = make;
/* Scalars Not a pure module */
